import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import assets from './assets'
import event from './event'
import featureFlags from './featureFlags'
import user from './event.user'

export default combineReducers({
  assets,
  event,
  featureFlags,
  user,
  form: formReducer,
})
